//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/NXObject.js";
let d=[[],[[["index"],"GetExpressionByIndex",{R_:{expression:"Expression"}},1,0],[["expressions"],"SetExpressions",{},1,0],[["expressions"],"SetImaginaryExpressions",{},1,0],[["index"],"GetImaginaryExpressionByIndex",{R_:{expression:"Expression"}},1,0],[["field","scale_factor"],"SetField",{},2,0],[[],"GetField",{R_:{field:"Fields.Field"}},0,0]],[]];
SPLM.Fields.ComplexVectorFieldWrapper = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.ComplexVectorFieldWrapper";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;